!(function () {
  const e = document.getElementById("view-transition-render-blocker");
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || i())
    e?.remove();
  else {
    setTimeout(() => {
      e?.remove();
    }, 0);
  }
  const t =
    "function" == typeof requestIdleCallback ? requestIdleCallback : setTimeout;
  function n(e) {
    return !(e instanceof ViewTransition) || i();
  }
  function i() {
    return (
      Number(navigator.hardwareConcurrency) <= 2 ||
      Number(navigator.deviceMemory) <= 2
    );
  }
  (window.addEventListener("pageswap", async (e) => {
    const { viewTransition: t } = e;
    if (n(t)) return void t?.skipTransition();
    (["pointerdown", "keydown"].forEach((e) => {
      document.addEventListener(
        e,
        () => {
          t.skipTransition();
        },
        { once: !0 },
      );
    }),
      document
        .querySelectorAll(
          "[data-view-transition-type]:not([data-view-transition-triggered])",
        )
        .forEach((e) => {
          e.removeAttribute("data-view-transition-type");
        }));
    const i = document.querySelector("[data-view-transition-triggered]"),
      a = i?.getAttribute("data-view-transition-type");
    a
      ? (t.types.clear(),
        t.types.add(a),
        sessionStorage.setItem("custom-transition-type", a))
      : (t.types.clear(),
        t.types.add("page-navigation"),
        sessionStorage.removeItem("custom-transition-type"));
  }),
    window.addEventListener("pagereveal", async (e) => {
      const { viewTransition: i } = e;
      if (n(i)) return void i?.skipTransition();
      const a = sessionStorage.getItem("custom-transition-type");
      a
        ? (i.types.clear(),
          i.types.add(a),
          await i.finished,
          i.types.clear(),
          i.types.add("page-navigation"),
          t(() => {
            (sessionStorage.removeItem("custom-transition-type"),
              document
                .querySelectorAll("[data-view-transition-type]")
                .forEach((e) => {
                  e.removeAttribute("data-view-transition-type");
                }));
          }))
        : (i.types.clear(), i.types.add("page-navigation"));
    }));
})();
